import React from 'react'
import PropTypes from 'prop-types'
import { Menu, styled } from '@material-ui/core'

const CustomsMenu = styled((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    boxShadow: 'rgb(232, 232, 234) 0px 2px 16px 0px',
    '& .MuiListItem-button:hover': {
      backgroundColor: theme.colors['primary-200'],
    },
  },
}))

const Menus = (props) => {
  const { children } = props

  return <CustomsMenu {...props}>{children}</CustomsMenu>
}

Menus.propTypes = {
  children: PropTypes.node,
}
export default Menus
